module.exports = __webpack_public_path__ + "static/img/img48.2fa85aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img48.png
// module id = FMoC
// module chunks = 1